import type { HistoryDeletionEntry } from "@/services/gpsdrive-history-deletions.service";

// "Apagar histórico" (pedido 2026-09-08) — o Traccar nunca perde a
// posição de verdade (ver comentário no model HistoryDeletion, backend);
// esconder o período apagado é feito aqui, no cliente, em cima do que
// /api/reports/route (ou qualquer outra fonte de posição) já devolveu.
// Só os registros ATIVOS (restoredAt nulo) escondem algo — um restaurado
// simplesmente para de filtrar, sem precisar re-buscar nada do Traccar.
export function activeDeletionRanges(
  deletions: HistoryDeletionEntry[] | undefined,
): { fromMs: number; toMs: number }[] {
  if (!deletions?.length) return [];
  return deletions
    .filter((d) => !d.restoredAt)
    .map((d) => ({ fromMs: new Date(d.periodFrom).getTime(), toMs: new Date(d.periodTo).getTime() }));
}

export function filterDeletedPositions<T extends { timestamp: string }>(
  positions: T[],
  deletions: HistoryDeletionEntry[] | undefined,
): T[] {
  const ranges = activeDeletionRanges(deletions);
  if (ranges.length === 0) return positions;
  return positions.filter((p) => {
    const t = new Date(p.timestamp).getTime();
    return !ranges.some((r) => t >= r.fromMs && t <= r.toMs);
  });
}
